var _style, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "379.43px",
    height: "468.62px",
    viewBox: "0 0 379.43 468.62",
    style: {
      enableBackground: "new 0 0 379.43 468.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:#B8B20F;}\r\n\t.st5{fill:#FFFF00;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st6{fill:#1C77C9;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st7{fill:#29ABE2;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94.3,160.12c-13.66,12.79-22.19,30.32-26.8,48.45s-5.55,36.98-5.9,55.69c-0.11,6.02-0.15,12.17,1.76,17.88 c1.91,5.71,6.13,10.99,11.94,12.56c-3.24,10.21-6.28,22.07-0.38,31.01c5.1,7.71,15.04,10.31,24.1,12.11 c24.14,4.8,48.94,8.21,73.33,4.93c11.74-1.58,23.87-5.03,32.14-13.51c8.27-8.47,11.1-23.12,3.51-32.21 c6.4-8.37,7.87-19.42,8.72-29.92c1.56-19.14,1.77-38.56-1.99-57.39s-11.7-37.16-24.85-51.15c-13.15-13.99-31.85-23.28-51.05-22.88 s-38.39,11.39-46.45,28.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.62,179.54c-9.07,7.38-19.15,13.45-28.27,20.76c-9.13,7.31-17.48,16.19-21.49,27.18 c-6.64,18.18,0.26,39.57,14.13,53.08c8.49,8.27,19.49,14.05,31.22,15.81s24.12-0.64,34.06-7.09c11.78-7.65,19.36-20.15,26.54-32.22 c3.24-5.45,6.6-11.34,6.23-17.67c-0.32-5.59-3.51-10.58-6.82-15.1c-10.66-14.57-23.59-27.35-37.16-39.26 c-3.55-3.12-7.37-6.29-12-7.21c-4.63-0.92-10.24,1.28-11.46,5.84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.49,240.3c1.16-1.35,3.2-2.06,5.09-1.78s3.55,1.55,4.14,3.16c0.24,0.65,0.31,1.34,0.6,1.97 c0.29,0.63,0.88,1.22,1.65,1.28c-2.36,3.78-4.73,7.56-7.09,11.34c-1.89-3.74-4.32-7.27-7.21-10.48c1.21-1.58,2.07-3.37,2.52-5.23"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 121.42,
    cy: 231.18,
    rx: 25.4,
    ry: 23.28
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 172.66,
    cy: 231.18,
    rx: 25.84,
    ry: 23.28
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171,197.11c-5.76,0.13-11.15,4.5-12.47,10.11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.44,196.42c6.02,1.63,11.26,5.91,14.06,11.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar5.7fae707d10b52daf310d62fcc69b3013.svg";
export { ForwardRef as ReactComponent };